<div class="filters__field">
  @if (programEntries().length > 0) {
    <fdr-past-performance-ui-searchable-dropdown
      [label]="'PD.LABELS.PROGRAM' | translate"
      [placeholder]="'PD.LABELS.SELECT_OPTION' | translate"
      [exclusiveSelection]="true"
      [closesOnSelection]="true"
      [entries]="programEntries()"
      [customDsyListConfObject]="dropdownListConfig"
    ></fdr-past-performance-ui-searchable-dropdown>
  } @else {
    <dsy-input-dropdown
      [label]="'PD.LABELS.PROGRAM' | translate"
      [placeholder]="'PD.LABELS.SELECT_OPTION' | translate"
      [isDisabled]="true"
      [entries]="[]"
    ></dsy-input-dropdown>
  }
</div>

<div class="filters__field">
  @if (productEntries().length > 0) {
    <fdr-past-performance-ui-searchable-dropdown
      [label]="'PD.LABELS.PRODUCT' | translate"
      [placeholder]="'PD.LABELS.SELECT_OPTION' | translate"
      [exclusiveSelection]="false"
      [closesOnSelection]="false"
      [entries]="productEntries()"
      [customDsyListConfObject]="dropdownListConfig"
      [renderCounterTag]="showProductsCounterTag()"
      [counterTagConfig]="counterTagConfig"
    ></fdr-past-performance-ui-searchable-dropdown>
  } @else {
    <dsy-input-dropdown
      [label]="'PD.LABELS.PRODUCT' | translate"
      [placeholder]="'PD.LABELS.SELECT_OPTION' | translate"
      [isDisabled]="true"
      [entries]="[]"
    ></dsy-input-dropdown>
  }
</div>

<fdr-past-performance-ui-date-picker
  [datesOptions]="datesOptions"
  [initialDateOption]="store.progDateOption()"
  [initialDateRange]="store.progDateRange()"
  [resetTrigger]="dateResetToken()"
  (dateChange)="onDateChange($event)"
  (suggestionChange)="onSuggestionChange($event)"
  (validityChange)="onDateValidityChange($event)"
></fdr-past-performance-ui-date-picker>
